import httpClient from './httpClient';

const baseEndpoint = '/api/shop/user'

const login = request => {
    return httpClient.post(`/login`, request)
}

const refreshToken = refreshTokenDTO => {
    return httpClient.post('/refreshJWT', refreshTokenDTO)
}

const fetchUserByEmail = email => {
    return httpClient.get(`${baseEndpoint}/secure/`, { params: { email }})
}

export {
    login,
    refreshToken,
    fetchUserByEmail
}